<template>
  <v-dialog v-model="dialog" :persistent="savable" width="600px">
    <v-card>
      <v-card-title class="mx-3">
        {{
          $t(
            isNew
              ? "CRUD.newInfo"
              : savable
              ? "CRUD.editInfo"
              : "CRUD.viewInfo",
            [$t("Template.ObjectName")]
          )
        }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>
            {{ $t("CRUD.backToList", [$t("Template.ObjectName")]) }}
          </span>
        </v-tooltip>
      </v-card-title>
      <v-card-text>
        <v-container>
          <ValidationObserver ref="observer">
            <v-row>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('MaterialCategory.Fields.material_category_name')"
                  rules="required"
                >
                  <v-text-field
                    required
                    :readonly="isView"
                    v-model="template.template_name"
                    :error-messages="
                      $resparse
                        .getErrorMsgs(serverErrors, 'template_name')
                        .concat(errors)
                    "
                  >
                    <template v-slot:label>
                      {{ $t("Template.Fields.template_name") }}
                      <span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  v-slot="{ errors }"
                  :name="$t('Template.Fields.sort')"
                  :rules="{regex: '^[0-9]+$', min:0 }"
                >
                  <v-text-field
                    required
                    :readonly="isView"
                    v-model="template.sort"
                    :error-messages="
                      $resparse
                        .getErrorMsgs(serverErrors, 'sort')
                        .concat(errors)
                    "
                  >
                    <template v-slot:label>
                      {{ $t("Template.Fields.sort") }}
                    </template>
                  </v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12"  v-if="settings && settings.sub_account_enable">
                <v-select
                  v-model="template.sub_account_pay_type"
                  :items="bankSelect"
                  item-value="value"
                  item-text="text"
                  :label="$t('Template.Fields.sub_account_pay_type')"
                ></v-select>
              </v-col>
              <v-col cols="12" v-if="settings && settings.sub_account_enable">
                <v-row>
                  <v-col cols="3" class="text-left">
                    {{
                      $t("Template.Fields.sub_accounts") + $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" class="pt-1">
                    <v-checkbox
                      v-model="subAccountsFlag"
                      :true-value="1"
                      :false-value="0"
                      persistent-hint
                      small
                      dense
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  subAccountsFlag == 1 &&
                  settings &&
                  settings.sub_account_enable
                "
              >
                <SearcherSubAccount
                  v-model="template.express_sub_account_id"
                  :label="$t('Template.Fields.express_sub_account')"
                  :bank_codes="[template.sub_account_pay_type]"
                />
              </v-col>
              <v-col
                cols="12"
                v-if="
                  subAccountsFlag == 1 &&
                  settings &&
                  settings.sub_account_enable
                "
              >
                <SearcherSubAccount
                  v-model="template.service_charge_sub_account_id"
                  :label="$t('Template.Fields.service_charge_sub_account')"
                  :bank_codes="[template.sub_account_pay_type]"
                />
              </v-col>
              <v-col
                cols="12"
                v-if="
                  subAccountsFlag == 1 &&
                  settings &&
                  settings.sub_account_enable
                "
              >
                <SearcherSubAccount
                  v-model="template.core_sub_account_id"
                  :label="$t('Template.Fields.core_sub_account')"
                  :bank_codes="[template.sub_account_pay_type]"
                />
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="accent" @click="save()">{{ $t("CRUD.save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { mapState } from "vuex";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from "vee-validate";
import Templates from "@/api/templates";
import SubAccounts from "@/api/sub_accounts";
import SearcherSubAccount from "@/components/plugins/SearcherSubAccount";

setInteractionMode("eager");

export default {
  name: "TemplateDetail",

  props: ["value", "mode"],

  components: {
    ValidationProvider,
    ValidationObserver,
    SearcherSubAccount,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    template: {},
    bankSelect: [],
    serverErrors: [],
    subAccountsFlag: 0,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value) {
          // 重设数据时要重置校验报错
          this.serverErrors = [];
          if (this.$refs && this.$refs.observer) this.$refs.observer.reset();
          this.template = JSON.parse(JSON.stringify(this.value)); // 生成新对象
          if (this.mode == "clone") {
            this.template.duplicate_id = this.template.id;
            this.template.id = 0;
          }
          if (this.bankSelect.length == 0) {
            SubAccounts.fetchBankSelect().then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.bankSelect = [
                    {
                      text: this.$t("Global.select"),
                      value: null,
                    },
                  ];
                  Object.keys(response.data.banks).forEach((key) => {
                    this.bankSelect.push({
                      text: response.data.banks[key],
                      value: key,
                    });
                  });
                }
              }.bind(this)
            );
          }
          if (
            this.value.express_sub_account_id ||
            this.value.service_charge_sub_account_id ||
            this.value.core_sub_account_id
          ) {
            this.subAccountsFlag = 1;
          } else {
            this.subAccountsFlag = 0;
          }
        }
      },
    },
    mode: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = !!this.mode;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.$emit("mode", null);
          this.$emit("input", null);
          this.$store.dispatch("fullscreenLoadingStop");
        }
      },
    },
  },

  methods: {
    save() {
      this.$store.dispatch("fullscreenLoading");
      // 先清理后台返回的错误
      this.serverErrors = [];
      // 做前端校验
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            //校验成功再提交
            if (this.subAccountsFlag == 0) {
              if (
                this.template.express_sub_account_id ||
                this.template.express_sub_account_id == null
              ) {
                delete this.template.express_sub_account_id;
              }
              if (
                this.template.service_charge_sub_account_id ||
                this.template.service_charge_sub_account_id == null
              ) {
                delete this.template.service_charge_sub_account_id;
              }
              if (
                this.template.core_sub_account_id ||
                this.template.core_sub_account_id == null
              ) {
                delete this.template.core_sub_account_id;
              }
            }
            Templates.save(this.template.id, this.template)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", this.template);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
};
</script>